import { Contact } from '@lockton-apps/shared/interfaces';
import { createAction, props } from '@ngrx/store';

export enum ContactsApiActionTypes {
  LoadContactsSuccess = '[Contacts API] Load Contacts Success',
  LoadContactsFailure = '[Contacts API] Load Contacts Failure',

  LoadClientContactsSuccess = '[Contacts API] Load Client Contacts Success',
  LoadClientContactsFailure = '[Contacts API] Load Client Contacts Failure',

  LoadContactSuccess = '[Contacts API] Load Contact Success',
  LoadContactFailure = '[Contacts API] Load Contact Failure',

  LoadAuthenticatedContactSuccess = '[Contacts API] Load Authenticated Contact Success',
  LoadAuthenticatedContactFailure = '[Contacts API] Load Authenticated Contact Failure',

  LoadContactSuccessThenLoadClient = '[Contacts API] Load Contact Success Then Load Client',

  AddContactSuccess = '[Contacts API] Add Contact Success',
  AddPrimaryClientContactSuccess = '[Contacts API] Add Primary Client Contact Success',
  AddContactFailure = '[Contacts API] Add Contact Failure',

  UpdateContactSuccess = '[Contacts API] Update Contact Success',
  UpdateContactFailure = '[Contacts API] Update Contact Failure',

  UpdateLanguageSuccess = '[Contacts API] Update Language Success',
  UpdateLanguageFailure = '[Contacts API] Update Language Failure',

  EnabledSuccess = '[Contacts API] Enabled Success',
  EnabledFailure = '[Contacts API] Enabled Failure',

  DisabledSuccess = '[Contacts API] Disabled Success',
  DisabledFailure = '[Contacts API] Disabled Failure',

  HasOpenEnquiriesSuccess = '[Contacts API] Has Open Enquiries Success',
  HasOpenEnquiriesFailure = '[Contacts API] Has Open Enquiries Failure',
}

export const ContactsApiActions = {
  loadContactsSuccess: createAction(
    ContactsApiActionTypes.LoadContactsSuccess,
    props<{ contacts: Contact[] }>()
  ),
  loadContactsFailure: createAction(
    ContactsApiActionTypes.LoadContactsFailure,
    props<{ error: unknown }>()
  ),
  loadClientContactsSuccess: createAction(
    ContactsApiActionTypes.LoadClientContactsSuccess,
    props<{ contacts: Contact[] }>()
  ),
  loadClientContactsFailure: createAction(
    ContactsApiActionTypes.LoadClientContactsFailure,
    props<{ error: unknown }>()
  ),
  loadContactSuccess: createAction(
    ContactsApiActionTypes.LoadContactSuccess,
    props<{ contact: Contact }>()
  ),
  loadContactFailure: createAction(
    ContactsApiActionTypes.LoadContactFailure,
    props<{ error: unknown }>()
  ),
  loadAuthenticatedContactSuccess: createAction(
    ContactsApiActionTypes.LoadAuthenticatedContactSuccess,
    props<{ contact: Contact }>()
  ),
  loadAuthenticatedContactFailure: createAction(
    ContactsApiActionTypes.LoadAuthenticatedContactFailure,
    props<{ error: unknown }>()
  ),

  loadContactSuccessThenLoadClient: createAction(
    ContactsApiActionTypes.LoadContactSuccessThenLoadClient,
    props<{ contact: Contact; clientId: number }>()
  ),

  addSuccess: createAction(
    ContactsApiActionTypes.AddContactSuccess,
    props<{ contact: Contact }>()
  ),

  addPrimaryClientContactSuccess: createAction(
    ContactsApiActionTypes.AddPrimaryClientContactSuccess,
    props<{ contact: Contact }>()
  ),

  addFailure: createAction(
    ContactsApiActionTypes.AddContactFailure,
    props<{ error: unknown }>()
  ),

  updateContactSuccess: createAction(
    ContactsApiActionTypes.UpdateContactSuccess,
    props<{ contact: Contact }>()
  ),

  updateContactFailure: createAction(
    ContactsApiActionTypes.UpdateContactFailure,
    props<{ error: unknown }>()
  ),

  updateLanguageSuccess: createAction(
    ContactsApiActionTypes.UpdateLanguageSuccess,
    props<{ contact: Contact }>()
  ),

  updateLanguageFailure: createAction(
    ContactsApiActionTypes.UpdateLanguageFailure,
    props<{ error: unknown }>()
  ),

  enabledSuccess: createAction(
    ContactsApiActionTypes.EnabledSuccess,
    props<{ userId: string }>()
  ),

  enabledFailure: createAction(
    ContactsApiActionTypes.EnabledFailure,
    props<{ userId: string; error: any }>()
  ),

  disabledSuccess: createAction(
    ContactsApiActionTypes.DisabledSuccess,
    props<{ userId: string }>()
  ),

  disabledFailure: createAction(
    ContactsApiActionTypes.DisabledFailure,
    props<{ userId: string; error: any }>()
  ),

  hasOpenEnquiriesSuccess: createAction(
    ContactsApiActionTypes.HasOpenEnquiriesSuccess,
    props<{ userId: string; quoteIds: number[] }>()
  ),

  hasOpenEnquiriesFailure: createAction(
    ContactsApiActionTypes.HasOpenEnquiriesFailure,
    props<{ userId: string; error: any }>()
  ),
};
